import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './EntryComponents.module.scss';

type NameProps = {
  value?: string;
  className?: string;
  error?: boolean;
  'data-test'?: string;
};

const Name: FC<NameProps> = ({
  value,
  className,
  error,
  ...props
}) => {
  const _className = classNames(className, {
    [styles.nameError]: error,
  });

  return (
    <p className={_className}
       title={value}
       data-test={classNames(props['data-test'], 'name-container')}>
      {value || '--'}
    </p>
  );
};

export default Name;
